export enum UserRoleTypesEnum {
  standard_user = 'standard_user',
  supervisor = 'supervisor',
  admin_staff = 'admin_staff',
}
